import { Link } from 'react-router-dom'
import { FaArrowRight, FaCode, FaMobile, FaBrain, FaComments, FaCogs, FaMobileAlt } from 'react-icons/fa'
import SEO from '../components/SEO'

const services = [
  {
    title: 'Web development',
    description:
      'Building responsive, modern websites and web applications using cutting-edge technologies like React, Node.js, and cloud platforms for optimal performance and user experience.',
    link: '/services/web-development',
    features: ['React & Node.js', 'Cloud Platforms', 'Full-Stack Development', 'Responsive Design'],
    icon: FaCode,
    image: '/images/home/services/web-3157323_1280.jpg',
  },
  {
    title: 'AI/ML Engineer',
    description:
      'Developing intelligent solutions and machine learning models to automate processes, analyze data, and create AI-powered applications that drive business innovation and efficiency.',
    link: '/services/ai-ml-engineer',
    features: ['Machine Learning Models', 'Data Analysis', 'AI Applications', 'Process Automation'],
    icon: FaBrain,
    image: '/images/home/services/web-design-3411373_1920.jpg',
  },
  {
    title: 'Mobile Apps',
    description:
      'Creating cross-platform mobile applications with React Native and Flutter, delivering native performance and seamless user experiences across iOS and Android devices.',
    link: '/services/mobile-apps',
    features: ['React Native', 'Flutter Development', 'Cross-Platform', 'Native Performance'],
    icon: FaMobile,
    image: '/images/home/services/mobile-app-development-company-8379091_1920.png',
  },
  {
    title: 'AI Chatbots & Agents',
    description:
      'Building intelligent conversational AI agents and chatbots powered by LLMs that understand context, provide personalized responses, and automate customer interactions.',
    link: '/services/ai-chatbots-agents',
    features: ['LLM-Powered Chatbots', 'Context Understanding', 'Personalized Responses', 'Customer Automation'],
    icon: FaComments,
    image: '/images/home/services/branding.png',
  },
  {
    title: 'AI Automation',
    description:
      'Creating intelligent automation workflows and AI-powered systems that streamline business processes, reduce manual work, and enable smart decision-making.',
    link: '/services/ai-automation',
    features: ['Workflow Automation', 'Business Process Optimization', 'Smart Decision-Making', 'NLP Integration'],
    icon: FaCogs,
    image: '/images/home/services/seo-7092114_1920.png',
  },
  {
    title: 'iOS & Android Apps',
    description:
      'Building native iOS and Android applications with platform-specific optimizations, ensuring high performance, security, and adherence to platform guidelines.',
    link: '/services/ios-android-apps',
    features: ['Native iOS Development', 'Native Android Development', 'Platform Optimization', 'Security & Compliance'],
    icon: FaMobileAlt,
    image: '/images/home/services/content.jpg',
  },
]

const Services = () => {
  return (
    <div>
      <SEO title="Our Services" description="Explore MindVista's comprehensive digital solutions including web dev, AI/ML, and mobile apps." />
      <section className="relative min-h-[62vh] overflow-hidden">
        <video autoPlay muted loop playsInline className="absolute inset-0 h-full w-full object-cover">
          <source src="/images/home/acheivements.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/75" />

        <div className="container-main relative z-10 flex min-h-[62vh] flex-col items-start justify-center">
          <span className="section-kicker">What We Do</span>
          <h1 className="mt-4 text-5xl font-bold md:text-7xl">Our Services</h1>
          <p className="mt-4 max-w-2xl text-lg text-[#b3b3b3]">Comprehensive digital solutions tailored to your needs.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="container-main grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {services.map((service, index) => {
            const Icon = service.icon
            const isPrimary = index === 0
            return (
              <article
                key={service.title}
                className={`overflow-hidden rounded-3xl transition-all duration-300 ${
                  isPrimary ? 'service-card-primary' : 'service-card-secondary'
                }`}
              >
                <div className="relative h-48">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-full w-full object-cover"
                    onError={(e) => {
                      e.currentTarget.src = `https://via.placeholder.com/600x320/1a1a1a/c8e64a?text=${encodeURIComponent(service.title)}`
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent" />
                  <div className={`absolute left-4 top-4 inline-flex h-11 w-11 items-center justify-center rounded-xl ${isPrimary ? 'bg-black/20 text-black' : 'bg-white/10 text-[rgb(249,193,37)]'}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                </div>

                <div className="p-6">
                  <h2 className={`text-3xl font-semibold ${isPrimary ? 'text-black' : 'text-white'}`}>{service.title}</h2>
                  <p className={`mt-3 text-sm leading-relaxed ${isPrimary ? 'text-black/80' : 'text-[#a8a8a8]'}`}>{service.description}</p>
                  <ul className="mt-4 grid gap-2">
                    {service.features.map((feature) => (
                      <li key={feature} className={`text-sm ${isPrimary ? 'text-black/80' : 'text-[#c6c6c6]'}`}>
                        • {feature}
                      </li>
                    ))}
                  </ul>
                  <Link to={service.link} className={`mt-6 inline-flex items-center gap-2 text-sm font-semibold ${isPrimary ? 'text-black' : 'text-[rgb(249,193,37)] hover:text-white'}`}>
                    Learn More
                    <FaArrowRight className="h-3.5 w-3.5" />
                  </Link>
                </div>
              </article>
            )
          })}
        </div>
      </section>
    </div>
  )
}

export default Services


